import { render, staticRenderFns } from "./training-agenda.vue?vue&type=template&id=2a111971&scoped=true"
import script from "./training-agenda.vue?vue&type=script&lang=js"
export * from "./training-agenda.vue?vue&type=script&lang=js"
import style0 from "./training-agenda.vue?vue&type=style&index=0&id=2a111971&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a111971",
  null
  
)

export default component.exports